export const PREFETCH_DISABLE_LIST: string[] = ['/wall-of-love']
